import { forwardRef } from 'react'
import { HeadingProps } from './Heading.types'
import { HeadingTypography } from './Heading.styles'

const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  (
    { variant = 'h1', className = '', value = '', children, styles, ...props },
    ref
  ) => {
    return (
      <HeadingTypography
        className={`Heading ${className}`}
        variant={variant}
        sx={styles}
        data-testid="heading"
        ref={ref}
        {...props}>
        {value}
        {children}
      </HeadingTypography>
    )
  }
)

Heading.displayName = 'Heading'
export default Heading
